import { Image, Flex } from "antd";

import { StatisticCard } from "shared/components";
import { utilityService } from "shared/services";
import projectsIcon from "projects/assets/images/projects.svg";
import actualSalesIcon from "sales/assets/images/actual_sales.svg";

import "./SubcontractorProjects.scss";
import variables from "../../../_variables.scss";
import { ISubcontractorProjects } from "projects/models";

interface SubcontractorProjectsProps {
  subcontractorProjects: ISubcontractorProjects;
}

export const SubcontractorProjects = ({ subcontractorProjects }: SubcontractorProjectsProps) => {
  return (
    <Flex gap={variables.gap} data-testid='subcontractorProjects'>
      <StatisticCard
        testId='totalProjects'
        title='Number of Projects'
        value={subcontractorProjects?.totalProjects}
        formatter={utilityService.statisticsFormatter}
        backgroundColor={variables.taupeColor}
        Icon={() => (
          <Image
            src={projectsIcon}
            alt='Projects Icon'
            preview={false}
            width={35}
          />
        )}
        width={variables.fullWidth}
      />
      <StatisticCard
        testId='totalProjectsValue'
        title='Total Projects Value'
        value={subcontractorProjects?.totalProjectsValue}
        prefix='$'
        formatter={utilityService.statisticsFormatter}
        backgroundColor={variables.paleGreenColor}
        Icon={() => (
          <Image
            src={actualSalesIcon}
            alt='Sales Icon'
            preview={false}
            width={35}
          />
        )}
        width={variables.fullWidth}
      />
    </Flex>
  );
};
